import script from "./TabContentRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./TabContentRequest.vue?vue&type=script&setup=true&lang=js"

import "./TabContentRequest.vue?vue&type=style&index=0&id=2eec8446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eec8446"]])

export default __exports__